
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/playground.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-playground-demo-playground"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/playground.en-US.md?type=demo')
};